import { dark as darkGreen, light as lightGreen } from "./palette--green";
import { dark as darkOrange, light as lightOrange } from "./palette--orange";

const palette = (themeMode = "light", paletteType = "orange") => {
	if (paletteType === "orange") {
		return themeMode === "dark" ? darkOrange : lightOrange;
	}
	return themeMode === "dark" ? darkGreen : lightGreen;
};

export default palette;
